import React from 'react';
import Fab from '@mui/material/Fab';
import PhoneIcon from '@mui/icons-material/Phone';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';

export default function StickyCTA() {
  return (
   <Box
  sx={{
    position: 'fixed',
    right: { xs: 35, sm: 18 },     // smaller offset on mobile
    bottom: { xs: 50, sm: 16 },    // smaller offset on mobile
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 0.8, sm: 1 },       // tighter spacing on mobile
    zIndex: 1200,
  }}
>
  <Fab
    color="primary"
    component="a"
    href="tel:+18125550123"
    aria-label="Call"
    size="medium" // smaller button looks better on mobile
    sx={{
      boxShadow: 3,
      '@media (max-width:600px)': { width: 46, height: 46 },
    }}
  >
    <PhoneIcon />
  </Fab>

  <Fab
    color="primary"
    component={RouterLink}
    to="/book"
    aria-label="Book"
    size="medium"
    sx={{
      boxShadow: 3,
      '@media (max-width:600px)': { width: 46, height: 46 },
    }}
  >
    <BookOnlineIcon />
  </Fab>
</Box>

  );
}
